import { useButtonPressedCallback } from '@zenbusiness/application-commons-clickstream';
import { WebView } from '@zenbusiness/application-commons-webview';
import Box from '@zenbusiness/zui/Box';
import CircularProgress from '@zenbusiness/zui/CircularProgress';
import IconButton from '@zenbusiness/zui/IconButton';
import Stack from '@zenbusiness/zui/Stack';
import Text from '@zenbusiness/zui/Text';
import PropTypes from 'prop-types';

import DocsIcon from '#client/images/docs.svg';

import { CircleStyled, MonthWrapperStyled } from './Document.styles';

function Document({ text, disabled, handleView, handleDownload, loading = false }) {
  const { isWebView } = WebView;
  const buttonViewPressed = useButtonPressedCallback({
    elementName: 'statements_preview',
    elementText: 'preview',
    appPageName: 'statements_screen'
  });
  const buttonDownloadPressed = useButtonPressedCallback({
    elementName: 'statements_download',
    elementText: 'download',
    appPageName: 'statements_screen'
  });

  // div doesn't have disabled prop, so we need to wrap it with a function
  const handleViewWithDisabled = () => {
    if (!disabled) {
      handleView();
      buttonViewPressed();
    }
  };

  const downloadHandler = (event) => {
    buttonDownloadPressed();
    event.stopPropagation();
    handleDownload();
  };

  return (
    <MonthWrapperStyled
      onClick={handleViewWithDisabled}
      role="listitem"
    >
      <Stack
        alignItems="center"
        direction="row"
        spacing="16px"
      >
        <CircleStyled>
          <DocsIcon />
        </CircleStyled>
        <Stack
          alignItems="center"
          direction="row"
          spacing="8px"
        >
          <Text
            size="xl"
            textTransform="capitalize"
            weight="medium"
          >
            {text}
          </Text>
          <Box
            alignItems="center"
            display="flex"
          >
            {loading && (
              <CircularProgress
                color="inherit"
                size={20}
              />
            )}
          </Box>
        </Stack>
      </Stack>
      {!isWebView && (
        <IconButton
          disabled={disabled}
          disableRipple
          iconSrc="/icon/micro/download-alt.svg"
          label="Download pdf button"
          onClick={downloadHandler}
          size="sm"
        />
      )}
    </MonthWrapperStyled>
  );
}

Document.propTypes = {
  text: PropTypes.string.isRequired,
  disabled: PropTypes.bool.isRequired,
  handleView: PropTypes.func.isRequired,
  handleDownload: PropTypes.func.isRequired,
  loading: PropTypes.bool
};

export default Document;
